export default __webpack_public_path__ + "static/media/S-025.48035af7.png";